export const BRAND_ASSETS = {
  homeHero: "/img/ecosystem/hero-couple.webp",
  coverageMap: "/img/ecosystem/coverage-map.jpeg",
  clinicalScan: "/img/ecosystem/scan-room.webp",
  metabolicSignals: "/img/ecosystem/metabolic-signals.webp",
  recoveryReadiness: "/img/ecosystem/recovery-home.webp",
  movementVitality: "/img/ecosystem/movement-vitality.webp",
  programLongevity: "/img/programs/program-longevity.webp",
  programHormonal: "/img/programs/program-hormonal.webp",
  programMetabolic: "/img/programs/program-metabolic.webp",
  programPerformance: "/img/programs/program-performance.webp",
  homeBloodKit: "/img/ecosystem/home-blood-kit.jpg",
};